import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";


function CalculationResultAttribute({ id, title, value }) {
  return (
    <Box
      id={id}
      sx={{
        display: "flex",
        justifyContent: "space-between" ,
        alignItems: "center",          
        backgroundColor: "#FFF",
        height: "46px",
        borderRadius: 1,
        px: 2,
        fontWeight: "bold",
        fontSize: 16,
        boxShadow: 3,
      }}
    >
      <Typography
        component='label'
        htmlFor={id}
        sx={{ fontSize: 16 }}
      >
        {title}
      </Typography>
      <Typography
        sx={{ fontSize: 16, fontWeight: "bold", alignItems: "right", justifyContent: "right" }}
      >
        {value}
      </Typography>
    </Box>
  )
};

CalculationResultAttribute.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CalculationResultAttribute;